// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";

export interface CreditApplicationParameter {
    CompanyInformation : CompanyInformation;
    BusinessProfile : BusinessProfile;
    AccountsPayableInformation : AccountsPayableInformation;
    PurchasingInformation ?: PurchasingInformation;
    TaxInformation ?: TaxInformation;
    TradeCreditReferences ?: TradeCreditReferences;
    BusinessCreditTerms ?: BusinessCreditTerms;
}

export interface CompanyInformation  {
    LegalCustomerName?: string;
    TradeDBAName?: string;
    BillingAddress?: string;
    BCity ?: string;
    BState?: string;
    BZip?: string;
    ShippingAddress?: string;
    SCity?: string;
    SState?: string;
    SZip?: string;
    Phone?: string;
    Fax?: string;
    Website?: string;
}

export interface BusinessProfile  {
    OrganizationType ?: string;
    YearEstablished ?: string;
    StateProvinceOfIncorporation ?: string;
    NumberOfEmployees  ?: string;
    ParentCompanyName ?: string;
    Address ?: string;
    City?: string;
    State?: string;
    Zip?: string;
    StyleOfBusiness ?: string;
    Subsidiary ?: string;
    Division ?: string;
    DunsNumber  ?: string;
}

export interface AccountsPayableInformation  {
    ContactName ?: string;
    Phone?: string;
    Fax?: string;
    Email ?: string;
    EmailAddressForInvoices ?: string;
}

export interface PurchasingInformation  {
    ContactName ?: string;
    Phone?: string;
    Fax?: string;
    Email ?: string;
    EmailAddressForInvoices ?: string;
}

export interface TaxInformation  {
    FederalTaxId  ?: string;
    WillYourPurchasesBeTaxable ?: string;
}
export interface BusinessCreditTerms  {
    SubmittedBy ?: string;
    Title ?: string;
    Date ?: string;
}

export interface TradeCreditReferences  {
    Ref1CompanyName  ?: string;
    Ref1Contact  ?: string;
    Ref1Address  ?: string;
    Ref1City   ?: string;
    Ref1State  ?: string;
    Ref1Zip  ?: string;
    Ref1Phone ?: string;
    Ref1Fax ?: string;
    Ref1Email  ?: string;
    Ref2CompanyName  ?: string;
    Ref2Contact  ?: string;
    Ref2Address  ?: string;
    Ref2City   ?: string;
    Ref2State  ?: string;
    Ref2Zip  ?: string;
    Ref2Phone ?: string;
    Ref2Fax ?: string;
    Ref2Email  ?: string;
    Ref3CompanyName  ?: string;
    Ref3Contact  ?: string;
    Ref3Address  ?: string;
    Ref3City   ?: string;
    Ref3State  ?: string;
    Ref3Zip  ?: string;
    Ref3Phone ?: string;
    Ref3Fax ?: string;
    Ref3Email  ?: string;
}


const submitCreditApplicationCustomUrl = "api/custom/creditApplication/form";

export async function submitCreditApplication(parameter: CreditApplicationParameter): Promise<any> {
    try {
        const result = await post<any>(submitCreditApplicationCustomUrl, parameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message,
            };
        }
        throw error;
    }
}
